export default __webpack_public_path__ + "static/media/Chat App.f74d5798.png";